import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BotAddButton = ({ botId, className }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Link to={`/marketplace/${botId}/bots/add`} type="button" className={className || `btn btn-outline-light btn-lg`}>
        {t('actions.hire')}
      </Link>
    </div>
  );
};

export default BotAddButton;
